module.exports = __webpack_public_path__ + "files/94334a011dfca04e0502afa47a3ca382.png";